<template>
	<div class="offer-verified__hotel">
		<h3 class="offer-verified__hotel-name">
			{{ name }}
		</h3>

		<HotelStars
			:rating="category"
			:show-suns="showSuns"
			class="offer-verified__hotel-stars"
		/>
	</div>
</template>

<script lang="ts" setup>
import HotelStars from '@lmt-rpb/HotelStars/HotelStars.vue';
import { computed } from 'vue';
import { isClientGermany } from '@utils/environmentUtils';
import type { ClientType } from '@/interfaces/common';

interface Props {
	name: string;
	category: number;
	client?: ClientType;
}

const props = withDefaults(defineProps<Props>(), {
	client: 'at',
});

const showSuns = computed(() => isClientGermany(props.client));
</script>

<style lang="scss" scoped>
.offer-verified {
	&__hotel {
		margin-bottom: 1.6rem;
		margin-left: 0;
	}

	&__hotel-name {
		display: inline;
		padding: 0;
		margin-right: 1rem;
		margin-bottom: 0.5rem;
		font-weight: $font-weight-semibold;
		color: $color-text;
		text-align: left;
		font-size: $font-small-1;
		font-family: $font-family-special;
		line-height: 1.2;
	}

	&__hotel-stars {
		width: auto;
		margin-top: 0;
		text-align: left;
	}

	@media (min-width: $breakpoint-medium) {
		&__hotel {
			justify-content: flex-start;
			margin-left: 0;
		}

		&__hotel-stars {
			margin: 0;
		}
	}

	@media (min-width: $breakpoint-extralarge) {
		&__hotel-name {
			font-size: $font-medium-3;
		}
	}
}
</style>
